import pick from 'lodash.pick';

const getSanitisedCartMenuItem = (item) => pick(item, ['quantity', 'uniqItemId', 'priority']);

export default getSanitisedCartMenuItem;
